/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetSymbolsPositions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSymbolsPositionsRequest = createAction<PayloadData<void>>('GET_SYMBOLS_POSITIONS__GET_SYMBOLS_POSITIONS__REQUEST');
export const getSymbolsPositionsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_SYMBOLS_POSITIONS__GET_SYMBOLS_POSITIONS__SUCCESS');
export const getSymbolsPositionsFailure = createAction<PayloadData<Error, void, true>>('GET_SYMBOLS_POSITIONS__GET_SYMBOLS_POSITIONS__FAILURE');

export const getSymbolsPositionsActions = [
    getSymbolsPositionsRequest,
    getSymbolsPositionsSuccess,
    getSymbolsPositionsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSymbolsPositions = (config?: GetSymbolsPositions$Config) => {
    return {
        CALL_API: {
            types: getSymbolsPositionsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/symbols-positions`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

